<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'App'
}
</script>
<style>
/* FE-114: 16px form controls on phones, so iOS Safari does not zoom on focus. */
@media (max-width: 767.98px) {
  .form-control,
  .form-select {
    font-size: 16px;
  }
}
</style>
